/** Used to upload a file to S3, having already got an upload URL */
export async function uploadFile(body: File | Blob, uploadUrl: string) {
  const response = await fetch(uploadUrl, { method: "PUT", body });
  if (response.status !== 200) throw new Error("Failed to upload");
  await new Promise((resolve) => setTimeout(resolve, 10000));
}
